/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2025-08-24 21:27:23
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-04-13 02:52:25
 * @FilePath: \利享乡村管理后台\src\api\ApiJson\ApiCourtship.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import config from '../nyConfig'
const ApiCourtship = {
    "招商信息审核列表": new config({url: '/courtship/auditing/pageCourtship', showSuccessMessage: false, useToken: true }),
    "招商信息审核列表统计": new config({url: '/courtship/auditing/countCourtship', showSuccessMessage: false, useToken: true }),
    "招商信息详情": new config({url: '/courtship/auditing/courtshipInfo', showSuccessMessage: false, useToken: true }),
    "修改招商基本信息": new config({url: '/courtship/auditing/updateBaseInfo', showSuccessMessage: true, useToken: true }),
    "修改招商位置": new config({url: '/courtship/auditing/updateAddressInfo', showSuccessMessage: true, useToken: true }),
    "修改招商联系人": new config({url: '/courtship/auditing/updateContactsInfo', showSuccessMessage: true, useToken: true }),
    "招商审核通过": new config({url: '/courtship/auditing/passAuditing', showSuccessMessage: true, useToken: true }),
    "招商审核拒绝": new config({url: '/courtship/auditing/refuseAuditing', showSuccessMessage: true, useToken: true }),
    "招商暂停/继续发布": new config({url: '/courtship/auditing/operationLand', showSuccessMessage: true, useToken: true }),
    "招商批量下架": new config({url: '/courtship/auditing/batchDeList', showSuccessMessage: true, useToken: true }),

}

export default ApiCourtship
